import React from 'react'
import { Link } from 'gatsby'
import { Button, Text } from 'grommet'

class MenuLink extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
        hover: false,
    };
    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHover() {
    this.setState({hover: !this.state.hover})
  }
  
  render() {
    const to = this.props.to
    const label = this.props.label
    const icon = this.props.icon //Home
    const text = (<Text color='text'>{label}</Text>)

    var linkStyle;
    if (this.state.hover) {
      linkStyle = {backgroundColor: "#555555"}
    } else {
      linkStyle = {backgroundColor: ''}
    }

    return(
      
      <Link to={to} style={linkStyle} onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}> 
        <Button 
          icon={icon}
          label={text}
          plain={true}
        />
      </Link>
    )
  }
}

export default MenuLink
